import type { MenuItem } from 'primevue/menuitem'
import { useLocalStorage } from '@vueuse/core'

const layoutConfig = useLocalStorage<{
  preset: LayoutPreset
  primary: LayoutPrimary
  surface?: LayoutSurface
  darkTheme: boolean
  menuMode: LayoutMenuMode
}>('layoutConfig', {
  preset: 'Aura',
  primary: 'emerald',
  surface: undefined,
  darkTheme: false,
  menuMode: 'static',
})

const layoutState = useLocalStorage<{
  staticMenuDesktopInactive: boolean
  overlayMenuActive: boolean
  profileSidebarVisible: boolean
  configSidebarVisible: boolean
  staticMenuMobileActive: boolean
  menuHoverActive: boolean
  activeMenuItem?: MenuItem
}>('layoutState', {
  staticMenuDesktopInactive: false,
  overlayMenuActive: false,
  profileSidebarVisible: false,
  configSidebarVisible: false,
  staticMenuMobileActive: false,
  menuHoverActive: false,
  activeMenuItem: undefined,
})

export function useTemplateLayout() {
  const setActiveMenuItem = (item: MenuItem) => {
    layoutState.value.activeMenuItem = item.value || item
  }

  const toggleDarkMode = () => {
    if (!document.startViewTransition) {
      executeDarkModeToggle()

      return
    }

    document.startViewTransition(() => executeDarkModeToggle())
  }

  const executeDarkModeToggle = () => {
    layoutConfig.value.darkTheme = !layoutConfig.value.darkTheme
    document.documentElement.classList.toggle('app-dark')
  }

  const initTheme = () => {
    layoutConfig.value.darkTheme = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches

    if (layoutConfig.value.darkTheme) {
      document.documentElement.classList.add('app-dark')
    }
  }

  const toggleMenu = () => {
    if (layoutConfig.value.menuMode === 'overlay') {
      layoutState.value.overlayMenuActive = !layoutState.value.overlayMenuActive
    }

    if (window.innerWidth > 991) {
      layoutState.value.staticMenuDesktopInactive =
        !layoutState.value.staticMenuDesktopInactive
    } else {
      layoutState.value.staticMenuMobileActive =
        !layoutState.value.staticMenuMobileActive
    }
  }

  return {
    layoutConfig,
    layoutState,
    toggleMenu,
    setActiveMenuItem,
    initTheme,
    toggleDarkMode,
  }
}
